import React, { useState, useEffect } from "react";
import { GlobalModal } from "../../../../global/GlobalModal";
import {
  GlobalSelectField,
  GlobalDateField,
  GlobalButton,
} from "../../../../global/forms/GlobalFormFields";
import { filterActiveMasterRows } from "../../../memberships/utils/masterLookupUtils";

const UpdateChequeStatusModal = ({
  open,
  onClose,
  statuses,
  onConfirm,
  currentStatusId,
}) => {
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const [clearanceDate, setClearanceDate] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setSelectedStatusId(currentStatusId?.toString() || "");
      setClearanceDate("");
      setError("");
    }
  }, [open, currentStatusId]);

  const selectedStatus = statuses.find(
    (s) => s.id.toString() === selectedStatusId,
  );
  const isCleared = String(selectedStatus?.status_name || "")
    .toLowerCase()
    .includes("clear");

  const handleConfirm = () => {
    if (!selectedStatusId) {
      setError("Please select a status.");
      return;
    }
    if (isCleared && !clearanceDate) {
      setError("Clearance Date is required for 'Cleared' status.");
      return;
    }
    onConfirm(selectedStatusId, isCleared ? clearanceDate : null);
  };

  const statusOptions = filterActiveMasterRows(statuses).map((s) => ({
    value: s.id.toString(),
    label: s.status_name.charAt(0).toUpperCase() + s.status_name.slice(1),
  }));

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title="Update Cheque Status"
      size="sm"
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="primary" onClick={handleConfirm}>
            Update Status
          </GlobalButton>
        </div>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <GlobalSelectField
          label="New Status"
          value={selectedStatusId}
          onChange={setSelectedStatusId}
          options={statusOptions}
          required
        />
        {isCleared && (
          <GlobalDateField
            label="Clearance Date"
            value={clearanceDate}
            onChange={setClearanceDate}
            required
          />
        )}
        {error && <p style={{ color: "var(--danger, #dc2626)", fontSize: "0.875rem", margin: 0 }}>{error}</p>}
      </div>
    </GlobalModal>
  );
};

export default UpdateChequeStatusModal;
